import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ReflectionService } from '../../shared/utilities/reflection.service';
import { ButtonConfig, ButtonSize } from './button.types';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ButtonComponent implements OnInit {
    @Input() disabled: boolean;
    @Input() disabledHint: string;
    @Input() loading: boolean;
    @Input() toolTip: string;
    @Input() iconToolTip: string;
    @Input() icon: string;
    @Input() secondIcon: string;
    @Input() secondIconToolTip: string;
    @Input() buttonRouterLink: any[] | string | null | undefined;
    @Input() buttonSize: ButtonSize;
    @Input() buttonConfig: ButtonConfig;
    @Output() clickedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
    constructor(private reflection: ReflectionService) {}

    ngOnInit(): void {
        if (this.reflection.isNotNullOrEmpty(this.iconToolTip) && this.reflection.isNullOrEmpty(this.icon)) {
            this.icon = 'info_outline';
        }
        this.toolTip = this.toolTip ? this.toolTip : '';
    }

    onSubmit() {
        this.clickedEvent.emit(true);
    }
}
